<template>
  <div class="xi" style="background: #f5f5f5">
    <hd-com></hd-com>
    <div class="banner">
      <div class="banner-text">
        <p>当前位置：<router-link to="/index">首页</router-link> 
            <i class="el-icon-arrow-right"></i><router-link to="/reservation/reservationIndex">医院列表</router-link>
            <i class="el-icon-arrow-right"></i><a style="cursor: pointer;" @click="$router.go(-1)">医院详情</a>
            <i class="el-icon-arrow-right"></i><a>医生详情</a></p>
      </div>
    </div>
    <div class="content">
      <div class="bannerImg">
        <div class="contentListDoc">
          <div class="contentListDocTop">
            <div class="DocTopImg">
              <img v-if="DocOrgDetail.photoFile" :src="http + DocOrgDetail.photoFile" />
              <img v-else src="../../assets/img/reservation/touxiang03.png" alt="" />
            </div>
            <div class="DocTopImgR">
              <div class="DocTopFlexS">
                <div class="DocTopImgRT">
                  <span class="DocTopImgName">{{ DocOrgDetail.userName }}</span>
                  <img v-if="DocOrgDetail.certificateNumber" src="../../assets/img/reservation/ilabel.png" style="width: 60px; height: 18px" />
                  <div v-if="DocOrgDetail.levelName == 1" class="DocTopTagZ">{{ DocOrgDetail.levelName }}</div>
                  <div v-if="DocOrgDetail.userCategoryType == 1" class="DocTopTagZ">专家</div>
                </div>
              </div>
              <div v-if="DocOrgDetail.certificateNumber">
                <i class="el-icon-document"></i>
                <span>证书编号：</span>
                <span>{{ certificateNumber.substr(0, 4) }}*******{{ certificateNumber.substr(certificateNumber.length - 4, certificateNumber.length - 1) }}</span>
              </div>
              <div class="DocTopFlexC" style="font-size: 14px; margin-top: 5px">
                <span>{{ DocOrgDetail.userTitleName }}</span>
                <span style="margin: 0 5px">|</span>
                <span>{{ DocOrgDetail.userPostName }}</span>
              </div>
              <div class="DocTopFlexC" style="font-size: 14px">
                <span class="">{{ DocOrgDetail.orgName }}</span>
                <span style="margin: 0 5px">|</span>
                <span>{{ DocOrgDetail.departmentName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-top">
        <div class="diagnose-tab">
          <span :class="doctorTable == 0 ? 'active' : ''" @click="getTab(0)">主页</span>
          <span :class="doctorTable == 1 ? 'active' : ''" @click="getTab(1)">医生介绍</span>
        </div>
      </div>
    </div>
    <div class="contentRes">
      <div class="contentList">
        <div style="padding: 20px 30px; background: #ffffff; margin-top: 20px" v-if="doctorTable == 0">
          <div class="contentPriceBox">
            <div class="contentListTop" style="margin-bottom: 10px">
              <div class="contentListLine"></div>
              <span>医生介绍</span>
            </div>
            <div style="font-size: 16px; color: #00afb5; cursor: pointer" @click="getTab(1)">查看完整介绍<i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="desDoc" style="" v-if="DocOrgDetail.expertise">擅长:{{ DocOrgDetail.expertise }}</div>
          <div class="desDoc" style="margin-top: 10px" v-if="DocOrgDetail.profile">简介:{{ DocOrgDetail.profile }}</div>
        </div>
        <div style="padding: 20px 30px; background: #ffffff; margin-top: 20px" v-if="doctorTable == 1">
          <div class="contentPriceBox">
            <div class="contentListTop" style="margin-bottom: 10px">
              <div class="contentListLine"></div>
              <span>医生介绍</span>
            </div>
          </div>
          <div class="" style="" v-if="DocOrgDetail.expertise">擅长:{{ DocOrgDetail.expertise }}</div>
          <div class="" style="margin-top: 10px" v-if="DocOrgDetail.profile">简介:{{ DocOrgDetail.profile }}</div>
        </div>
        <div style="padding: 20px 30px; background: #ffffff; margin-top: 20px" v-if="doctorTable == 0">
          <div class="contentPriceBox">
            <div class="contentListTop" style="margin-bottom: 10px">
              <div class="contentListLine"></div>
              <span>预约挂号</span> <span style="margin-left: 10px; color: #666666; font-size: 16px; margin-top: 3px">近一周的挂号信息</span>
            </div>
          </div>
          <div class="DocTopFlexWrap" style="margin-top: 20px">
            <div v-for="(item, index) in DocTimeList" :key="index">
              <div class="DocTopFlexC" style="margin-bottom: 20px">
                <div class="DocDetailYuTitle" style="letter-spacing: 2px">
                  <span>{{ item.scheduleDateS }}</span
                  ><span style="margin: 0 5px">{{ item.weekDayW }}</span> <span>{{ item.timePeriod == 1 ? "上午" : "下午" }}</span>
                  <div class="DocDetailYuTag">
                    {{ item.scheduleDateDay == 0 ? "今天" : item.scheduleDateDay + "天后" }}
                  </div>
                </div>
                <div class="DocDetailYuBox" style="padding: 2px 0" @click="goNextInfo(item)">预约时间</div>
              </div>
            </div>
          </div>

          <div v-if="DocTimeList.length == 0" style="margin-top: 50px; display: flex; align-items: center; flex-direction: column">
            <img src="../../assets/img/consultation/adefault.png" style="width: 256px; height: 140px" alt="" srcset="" />
            <span style="color: #666666">暂无数据！</span>
          </div>
        </div>
      </div>
      <div class="contentListRight">
        <div style="margin: 19px 31px 28px 23px">
          <div class="contentListTopR">
            <div class="contentListLineR"></div>
            <span>温馨提示</span>
          </div>
          <div style="font-size: 16px; color: #ff0000; line-height: 24px; margin-top: 18px">本系统仅提供辅助参考功能，诊疗决策须由执业医师独立完成，提交的所有内容，仅您本人与医生可见，请放心！</div>
        </div>
      </div>
      <el-dialog title="选择预约时段" :visible.sync="timeDialogVisible" width="30%">
        <div class="DocTopFlexWrap">
          <div v-for="(item, index) in DocOrgTimeList.scheduleDetailList" :key="index" style="width: 49%">
            <div class="" v-if="item.isQuantity != 0" @click="goscheduleId(item)">
              <div :class="scheduleId == item.scheduleId ? 'popupTitleTagCheck1 DocTopFlexS' : 'popupTitleTag1 DocTopFlexS'">
                <span>{{ item.startTime + "--" + item.endTime }} </span>
                <span v-if="item.isQuantity != 0"
                  >门诊预约<span style="margin-left: 5px">
                    <span style="color: #00a3a9">￥{{ item.price }}</span></span
                  ></span
                >
              </div>
            </div>
            <div class="" v-if="item.isQuantity == 0" style="opacity: 0.5">
              <div class="popupTitleTag1 DocTopFlexS">
                <span>{{ item.startTime + "--" + item.endTime }} </span>
                <span v-if="item.isQuantity == 0">(已约满)</span>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="canTimeDialogVisible">取 消</el-button>
          <el-button type="primary" @click="sureTimeDialogVisible">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <ft-com></ft-com>
  </div>
</template>

<script>
import { consultationMain } from "../../components/consultation/consultation";
import { reservationMain } from "../../components/reservation/reservation";
import hdCom from "../../components/header";
import ftCom from "../../components/footer";
const now = new Date(); // 创建 Date 对象，包含当前日期和时间
// 获取年、月、日（注意月份从 0 开始，需要 +1）
const year = now.getFullYear(); // 2025（四位年份）
const month = now.getMonth() + 1; // 6（实际是 6 月，但 getMonth() 返回 5）
const day = now.getDate(); // 9（当月的第几天）
const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
export default {
  components: {
    hdCom,
    ftCom,
  },
  data() {
    var reservationMainItemDrug = new reservationMain(this.TokenClient, this.Services.Drug);
    var consultationMainItem = new consultationMain(this.TokenClient, this.Services.Authorization);
    var consultationDrugItem = new consultationMain(this.TokenClient, this.Services.Drug);
    return {
      reservationDomainDrug: reservationMainItemDrug,
      consultationDomain: consultationMainItem,
      consultationDrugDomain: consultationDrugItem,
      DocOrgDetail: JSON.parse(this.$route.query.DocDetail),
      doctorTable: 0,
      DocTimeList: [],
      DocOrgTimeList: {},
      DocOrgTimeListDetail: {},
      scheduleId: 0,
      pageIndex: 1,
      pageTotal: 0,
      pageCount: 0,
      http: "",
      certificateNumber: "",
      type: 0,
      timeDialogVisible: false,
    };
  },
  mounted() {
    this.http = this.Services.ossUpload;
    this.certificateNumber = this.DocOrgDetail.certificateNumber.split("-").join("");
    this.getDocListData();
    this.GetDoctorDetailTime();
  },
  methods: {
    sureTimeDialogVisible() {
      if (this.scheduleId == 0) {
        this.$message({
          message: "请选择预约时间",
          type: "warning",
        });
        return;
      }
      let params = {
        scheduleId: this.DocOrgTimeListDetail.scheduleId,
        orgName: this.DocOrgDetail.orgName,
        scheduleDateS: this.DocOrgTimeList.scheduleDateS,
        weekDayW: this.DocOrgTimeList.weekDayW,
        timePeriod: this.DocOrgTimeList.timePeriod,
        scheduleDateDay: this.DocOrgTimeList.scheduleDateDay,
        price: this.DocOrgTimeListDetail.price,
        orgRegionFullName: this.DocOrgDetail.orgRegionFullName,
        userName: this.DocOrgDetail.userName,
        certificateNumber: this.DocOrgDetail.certificateNumber,
        userCategoryType: this.DocOrgDetail.userCategoryType,
        userTitleName: this.DocOrgDetail.userTitleName,
        userPostName: this.DocOrgDetail.userPostName,
        photoFile: this.DocOrgDetail.photoFile,
        startTime: this.DocOrgTimeListDetail.startTime,
        endTime: this.DocOrgTimeListDetail.endTime,
      };
      this.$router.push({
        path: "/reservation/reservationDocDetailInfo",
        query: {
          orderDetail: JSON.stringify(params),
        },
      });
    },
    canTimeDialogVisible() {
      this.scheduleId = 0;
      this.timeDialogVisible = false;
    },
    goNextInfo(item) {
      this.scheduleId = 0;
      console.log(item);
      this.DocOrgTimeList = item;
      this.timeDialogVisible = true;
    },
    getTab(e) {
      this.doctorTable = e;
    },
    goscheduleId(e) {
      this.scheduleId = e.scheduleId;
      this.DocOrgTimeListDetail = e;
    },
    getDaysBetweenDates(dateStr1, dateStr2) {
      // 将日期字符串转换为Date对象
      const date1 = new Date(dateStr1);
      const date2 = new Date(dateStr2);

      // 计算时间差（毫秒）
      const timeDiff = Math.abs(date2.getTime() - date1.getTime());

      // 将毫秒转换为天数
      const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

      return daysDiff;
    },
    GetDoctorDetailTime() {
      var _this = this;
      _this.reservationDomainDrug.GetAvailableScheduleByDoctorDetail(
        _this.DocOrgDetail.id,
        function (data) {
          for (let i = 0; i < data.data.length; i++) {
            data.data[i].scheduleDateS = data.data[i].scheduleDate.slice(0, 10);
            data.data[i].scheduleDateDay = _this.getDaysBetweenDates(data.data[i].scheduleDateS, formattedDate);
            if (data.data[i].weekDay == 1) {
              data.data[i].weekDayW = "周一";
            }
            if (data.data[i].weekDay == 2) {
              data.data[i].weekDayW = "周二";
            }
            if (data.data[i].weekDay == 3) {
              data.data[i].weekDayW = "周三";
            }
            if (data.data[i].weekDay == 4) {
              data.data[i].weekDayW = "周四";
            }
            if (data.data[i].weekDay == 5) {
              data.data[i].weekDayW = "周五";
            }
            if (data.data[i].weekDay == 6) {
              data.data[i].weekDayW = "周六";
            }
            if (data.data[i].weekDay == 0) {
              data.data[i].weekDayW = "周日";
            }
            data.data[i].scheduleDetailList.map((res1) => {
              res1.isQuantity = res1.quantity - res1.currentAppointmentCount;
            });
          }
          _this.DocTimeList = data.data;
          console.log(_this.DocTimeList);
        },
        function (error) {
          _this.DocTimeList = [];
          console.log("", error);
        }
      );
    },
    getDocListData() {
      var _this = this;
      _this.consultationDomain.GetUserInfo(
        _this.DocOrgDetail.id,
        function (data) {
          _this.DocOrgDetail.profile = data.data.profile;
        },
        function (error) {
          _this.DocOrgDetail = {};
          console.log("", error);
        }
      );
    },
  },
};
</script>

<style scoped>
.banner-text {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 10px;
}
.content {
  width: 1200px;
  margin: 0 auto;
}
.contentRes {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  min-height: 800px;
  margin-bottom: 20px;
}
.bannerImg {
  /* height: 150px; */
  background: linear-gradient(90deg, #00afb5, #12c7ac);
  border-radius: 6px 6px 0px 0px;
}
.content-top {
  height: 64px;
  background: #ffffff;
  box-shadow: 2px 0 5px rgba(102, 102, 102, 0.08);
}
.diagnose-tab {
  padding: 20px 30px;
  padding-bottom: 0px;
  cursor: pointer;
  border-radius: 0px 0px 6px 6px;
}
.diagnose-tab span {
  margin-right: 50px;
  color: #808080;
  font-size: 16px;
  padding-bottom: 20px;
}

.diagnose-tab span.active {
  color: #00a8ae;
  border-bottom: 2px solid #00a8ae;
}
.contentList {
  margin-top: 20px;

  width: 800px;
}
.contentListTop {
  display: flex;
  align-items: center;
  font-size: 20px;
}
.contentListTop3 {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.contentListLine {
  width: 3px;
  height: 20px;
  background: #00afb5;
  border-radius: 2px;
}
.contentListTop span {
  font-size: 20px;
  margin-left: 10px;
}
.contentListRight {
  width: 380px;
  height: 180px;
  background: #ffffff;
  margin-top: 20px;
}
.contentListTopR {
  display: flex;
  align-items: center;
}
.contentListLineR {
  width: 3px;
  height: 20px;
  background: #ff0000;
  border-radius: 2px;
}
.contentListTopR span {
  font-size: 20px;
  margin-left: 10px;
  color: #ff0000;
}
.contentListDoc {
  padding: 30px;
}
.contentListDocTop {
  display: flex;
  align-items: center;
}
.DocTopImg {
  width: 120px;
  height: 120px;
  position: relative;
}
.DocTopImg img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.DocTopTag {
  width: 60px;
  background: #00afb5;
  border-radius: 4px;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.DocTopImgR {
  margin-left: 16px;
  border-radius: 8px;
  padding: 20px;
  padding-bottom: 15px;
  position: relative;
  width: 700px;
  background: #21c2b9;
  color: #ffffff;
}
.DocTopImgName {
  font-weight: bold;
  font-size: 18px;
  margin-right: 7px;
}
.DocTopTagZ {
  width: 40px;
  background: #677aec;
  border-radius: 3px;
  font-size: 10px;
  color: #ffffff;
  text-align: center;
  margin-left: 7px;
}
.DocTopImgRT {
  display: flex;
  align-items: center;
}
.DocTopFlexC {
  display: flex;
  align-items: center;
}
.DocTopFlexS {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.DocTopFlexWrap {
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  flex-wrap: wrap;
}
.desDoc {
  margin-top: 10px;
  font-size: 16px;
  color: #666666;
  overflow: hidden; /*超出部分隐藏*/
  /* white-space: nowrap; */
  text-overflow: ellipsis; /*超出部分文字以...显示*/
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.contentPriceBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.DocDetailYuTitle {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  display: flex;
  align-items: baseline;
}
.DocDetailYuTag {
  width: 50px;
  text-align: center;
  /* padding: 2px 0; */
  font-size: 12px;
  color: #999999;
  border-radius: 2px;
  border: 1px solid #cccccc;
  margin-left: 8px;
}
.DocDetailYuBox {
  width: 80px;
  background: #00afb5;
  border-radius: 4px;
  text-align: center;
  padding: 5px 0;
  font-size: 14px;
  color: #ffffff;
  margin-left: 20px;
  cursor: pointer;
}
.popupTitleTagCheck1 {
  background: #f3f9f9;
  border-radius: 2px;
  border: 1px solid #00afb5;
  margin-bottom: 10px;
  padding: 10px 20px;
}
.popupTitleTag1 {
  background: #f5f5f5;
  border-radius: 2px;
  margin-bottom: 10px;
  padding: 10px 20px;
}
</style>
